import { Controller } from "@hotwired/stimulus"

// Handles the toggle behavior for proxy submission settings in role forms
export default class extends Controller {
  static targets = [
    "enabledCheckbox",
    "scopeContainer",
    "scopeSelect",
    "employeeSelectContainer",
    "teamSelectContainer",
    "ownTeamsHint",
  ]
  static values = { recordType: String }

  connect() {
    this.updateVisibility()
  }

  toggleScope() {
    this.updateVisibility()
  }

  toggleEmployeeSelect() {
    this.updateScopeSelectVisibility()
  }

  updateVisibility() {
    const isEnabled = this.enabledCheckboxTarget.checked

    if (isEnabled) {
      this.scopeContainerTarget.classList.remove("hidden")
    } else {
      this.scopeContainerTarget.classList.add("hidden")
    }

    this.updateScopeSelectVisibility()
  }

  updateScopeSelectVisibility() {
    if (!this.hasScopeSelectTarget) return

    const scope = this.scopeSelectTarget.value
    const isEnabled = this.enabledCheckboxTarget.checked

    // Employee select - show only when scope is 'selected'
    if (this.hasEmployeeSelectContainerTarget) {
      if (isEnabled && scope === "selected") {
        this.employeeSelectContainerTarget.classList.remove("hidden")
      } else {
        this.employeeSelectContainerTarget.classList.add("hidden")
      }
    }

    // Team select - show only when scope is 'team'
    if (this.hasTeamSelectContainerTarget) {
      if (isEnabled && scope === "team") {
        this.teamSelectContainerTarget.classList.remove("hidden")
      } else {
        this.teamSelectContainerTarget.classList.add("hidden")
      }
    }

    // Own-teams hint - show only when scope is 'own_teams' (it takes no configuration)
    if (this.hasOwnTeamsHintTarget) {
      if (isEnabled && scope === "own_teams") {
        this.ownTeamsHintTarget.classList.remove("hidden")
      } else {
        this.ownTeamsHintTarget.classList.add("hidden")
      }
    }
  }
}
